module.exports = __webpack_public_path__ + "img/warning.7a49be37.png";